import { useSearchParams } from 'react-router';
import { ReviewClustersTab } from '../components/bot/ReviewClustersTab';
import { UnrecognizedCommentsTab } from '../components/bot/UnrecognizedCommentsTab';
import { useBotRoute } from '../lib/useBotRoute';

const VIEWS = [
  { key: 'grouped', label: 'Grouped' },
  { key: 'list', label: 'One by one' },
] as const;

/**
 * Bot workspace → Review (hub-ui-step1 spec U7): messages the bot did not understand.
 * Grouped (clusters, one decision per group, gold labels) is the default; One by one is the
 * per-message list. The view is in the URL (?view=list) so it can be linked.
 */
export function BotReview() {
  const { system, botId } = useBotRoute();
  const [params, setParams] = useSearchParams();
  const view = params.get('view') === 'list' ? 'list' : 'grouped';
  const k = `${system}:${botId}`;
  return (
    <div className="space-y-4 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Review</h1>
        <div role="tablist" className="inline-flex overflow-hidden rounded border border-gray-300 text-sm">
          {VIEWS.map((v) => (
            <button
              key={v.key}
              role="tab"
              aria-selected={view === v.key}
              onClick={() => setParams(v.key === 'list' ? { view: 'list' } : {}, { replace: true })}
              className={`px-3 py-1 ${view === v.key ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
      <p className="text-sm text-gray-600">
        Messages this bot did not understand. Grouped merges similar messages, so one decision handles them all.
      </p>
      {view === 'grouped' ? (
        <ReviewClustersTab key={k} system={system} botId={botId} />
      ) : (
        <UnrecognizedCommentsTab key={k} system={system} botId={botId} />
      )}
    </div>
  );
}
